export default __webpack_public_path__ + "static/media/konstantin_xl.6e028a40.jpg";